export default function defer(func, delay = 0){
  return setTimeout(() => { func() }, delay)
}
